module.exports = __webpack_public_path__ + "img/企业历程ico.d42f6be7.png";